var styles = {"soldBadge":"index-module_soldBadge__2tOO-"};

export { styles as default };
//# sourceMappingURL=index.module.css.js.map
